import { useState } from "react";
import Layout from "../../components/Layout";
import { useAuth } from "../../context/AuthContext";
import SubscribersPane from "./SubscribersPane";
import { StatsPane, UsersPane, OrgsPane } from "./AdminHome";
import { Users, CreditCard, IdentificationBadge, ChartBar, Buildings } from "@phosphor-icons/react";

const TABS = [
    { key: "stats", label: "Statistiche", icon: ChartBar },
    { key: "subscribers", label: "Abbonamenti", icon: CreditCard },
    { key: "accounts", label: "Account", icon: IdentificationBadge },
    { key: "orgs", label: "Organizzazioni", icon: Buildings },
];

export default function Subscribers() {
    const { user } = useAuth();
    const [tab, setTab] = useState("stats");
    return (
        <Layout>
            <div className="mb-6 fade-up" data-testid="admin-subscribers-page">
                <div className="overline mb-2">Amministrazione</div>
                <h1 className="font-display-black text-3xl sm:text-4xl text-white flex items-center gap-3">
                    <Users size={30} weight="duotone" className="text-[#22D3EE]" /> Utenti
                </h1>
                <p className="text-sm text-slate-400 mt-2 max-w-2xl">
                    Statistiche, abbonamenti, account e organizzazioni degli utenti registrati.
                </p>
            </div>
            <div className="border-b border-white/[0.08] mb-6">
                <nav className="flex gap-1 overflow-x-auto" role="tablist" aria-label="Sezioni utenti">
                    {TABS.map((t) => {
                        const Icon = t.icon;
                        const active = tab === t.key;
                        return (
                            <button
                                key={t.key}
                                onClick={() => setTab(t.key)}
                                data-testid={`utenti-tab-${t.key}`}
                                role="tab"
                                aria-selected={active}
                                className={`flex items-center gap-2 px-4 h-11 text-sm font-semibold border-b-2 -mb-px whitespace-nowrap transition-colors ${
                                    active
                                        ? "border-[#22D3EE] text-white"
                                        : "border-transparent text-slate-400 hover:text-white"
                                }`}
                            >
                                <Icon size={16} weight={active ? "fill" : "regular"} />
                                {t.label}
                            </button>
                        );
                    })}
                </nav>
            </div>
            {tab === "stats" && <StatsPane />}
            {tab === "subscribers" && <SubscribersPane meOrgId={user?.organization_id} />}
            {tab === "accounts" && <UsersPane meId={user?.id} />}
            {tab === "orgs" && <OrgsPane meOrgId={user?.organization_id} />}
        </Layout>
    );
}
